// extracted by mini-css-extract-plugin
export var resizer = "_ia-0";